export const AdminPermissions = {
  // Extraction: categories and document types (with their flow configs)
  // belong to the extraction module, hence the `admin.extraction.` prefix.
  CATEGORY_MANAGE: "admin.extraction.category.manage",
  CATEGORY_VIEW: "admin.extraction.category.view",
  DOCTYPE_MANAGE: "admin.extraction.doctype.manage",
  DOCTYPE_VIEW: "admin.extraction.doctype.view",

  // Dashboard
  DASHBOARD_VIEW: "admin.dashboard.view",

  // Mapping plugin config (mapping service /plugin-configs, every service and field)
  MAPPING_CONFIG_VIEW: "admin.mapping.config.view",
  MAPPING_CONFIG_MANAGE: "admin.mapping.config.manage",

  // Monitoring
  MONITORING_VIEW: "admin.monitoring.view",
  // Every organisation in monitoring, the dashboard and usage (core reports it
  // as `scope.cross_org`), and the Organisations page.
  MONITORING_VIEW_ALL: "admin.monitoring.view.all",

  // Provider
  PROVIDER_VIEW: "admin.provider.view",
  // Admin model prices (PUT/POST/DELETE /providers/{key}/prices/...).
  PROVIDER_MANAGE: "admin.provider.manage",
  PROVIDER_CREDENTIAL_MANAGE: "admin.provider.credential.manage",
  PROVIDER_CREDENTIAL_VIEW: "admin.provider.credential.view",
  PROVIDER_MODEL_MANAGE: "admin.provider.model.manage",
  PROVIDER_MODEL_VIEW: "admin.provider.model.view",
  // Rotate the platform encryption key (Super Admin only).
  PROVIDER_ENCRYPTION_ROTATE: "admin.provider.encryption.rotate",

  // Access management (BeeHive users, roles and permission catalogue, through
  // core). Core requires ACCESS plus one of the others on every endpoint.
  ACCESS: "admin.access",
  ACCESS_VIEW: "admin.access.view",
  ACCESS_MANAGE: "admin.access.manage",
  ACCESS_PERMISSIONS_MANAGE: "admin.access.permissions.manage",
} as const;

export type AdminPermission =
  (typeof AdminPermissions)[keyof typeof AdminPermissions];
